import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BreadCrumbComponent } from './breadcrumb/breadcrumb.component';
import { BreadCrumbsComponent } from './breadcrumbs.component';

@NgModule({
  imports: [CommonModule, RouterModule, BreadCrumbsComponent, BreadCrumbComponent],
  exports: [BreadCrumbsComponent, BreadCrumbComponent],
})
export class BreadCrumbsModule {}
